(function(){
  if(window.__akhInit)return;window.__akhInit=true;
  function qa(r,s){return [].slice.call(r.querySelectorAll(s))}
  function idx(el){return Math.round(el.scrollLeft/Math.max(1,el.clientWidth))}

  function hero(root){
    if(root.dataset.akh)return;root.dataset.akh='1';
    var track=root.querySelector('.akh-hero__slides');if(!track)return;
    var n=track.children.length,dots=qa(root,'.akh-hero__dots button');
    function go(i){track.scrollTo({left:track.clientWidth*((i+n)%n),behavior:'smooth'})}
    function mark(){var i=idx(track);dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)})}
    var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(mark,80)},{passive:true});
    dots.forEach(function(d,k){d.addEventListener('click',function(){go(k);restart()})});
    var p=root.querySelector('.akh-hero__arrow--prev'),x=root.querySelector('.akh-hero__arrow--next');
    if(p)p.addEventListener('click',function(){go(idx(track)-1);restart()});
    if(x)x.addEventListener('click',function(){go(idx(track)+1);restart()});
    var delay=parseInt(root.dataset.autoplay||'0',10)*1000,timer=null;
    function restart(){if(timer)clearInterval(timer);if(delay>0&&n>1)timer=setInterval(function(){go(idx(track)+1)},delay)}
    root.addEventListener('mouseenter',function(){if(timer)clearInterval(timer)});
    root.addEventListener('mouseleave',restart);
    track.addEventListener('touchstart',function(){if(timer)clearInterval(timer)},{passive:true});
    track.addEventListener('touchend',restart,{passive:true});
    restart();mark();
  }

  function prods(root){
    if(root.dataset.akh)return;root.dataset.akh='1';
    var row=root.querySelector('.akh-prods__row');if(!row)return;
    function step(dir){var c=row.querySelector('.akh-card');var w=c?c.getBoundingClientRect().width+16:row.clientWidth/2;row.scrollBy({left:dir*w*2,behavior:'smooth'})}
    var p=root.querySelector('.akh-arrow--prev'),x=root.querySelector('.akh-arrow--next');
    if(p)p.addEventListener('click',function(){step(-1)});
    if(x)x.addEventListener('click',function(){step(1)});
  }

  function boot(scope){
    scope=scope||document;
    qa(scope,'.akh-hero').forEach(hero);
    qa(scope,'.akh-prods').forEach(prods);
    if(document.querySelector('.akh-bnav'))document.body.classList.add('akh-has-bnav');
  }
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',function(){boot()});
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
